<template>
  <div>
    <div class="container">
      <div class="infoContain">
        <div>
          <ValidationObserver v-slot="{ handleSubmit }">
            <form class="infoBoxForm" @submit.prevent="handleSubmit(onClickSubmit)">
              <div class="flex mobileFlex">
                <ValidationProvider class="inputBox infoBox wd50" name="아이디" rules="required|id" v-slot="{errors}">
                  <label>아이디<span class="labelItem">*</span></label>
                  <input v-model="signupInfo.id" maxlength="20">
                  <input type="button" value="중복확인" @click="onClickConfirmId" :disabled="errors[0] != null">
                  <span class="notValidationTxt">{{errors[0]}}</span>
                </ValidationProvider>
                <ValidationProvider class="inputBox infoBox wd50" name="이메일" rules="required|email" v-slot="{errors}">
                  <label>이메일<span class="labelItem">*</span></label>
                  <input v-model="signupInfo.email">
                  <span class="notValidationTxt">{{errors[0]}}</span>
                </ValidationProvider>
              </div>
              <div class="flex mobileFlex">
                <ValidationProvider class="inputBox infoBox wd50" name="비밀번호" rules="required|pw" vid="비밀번호" v-slot="{errors}">
                  <label>비밀번호<span class="labelItem">*</span></label>
                  <input type="password" v-model="signupInfo.password" maxlength="16" autocomplete="new-password">
                  <span class="notValidationTxt">{{errors[0]}}</span>
                </ValidationProvider>
                <ValidationProvider class="inputBox infoBox wd50" name="휴대폰번호" rules="required|mobileTel" v-slot="{errors}">
                  <label>휴대폰 번호<span class="labelItem">*</span></label>
                  <input v-model="signupInfo.phoneNumber" @keypress="eventUtil.onKeyPressForOnlyDigit($event)">
                  <span class="notValidationTxt">{{errors[0]}}</span>
                </ValidationProvider>
              </div>
              <div class="flex mobileFlex">
                <ValidationProvider class="inputBox infoBox wd50" name="비밀번호 재확인" rules="required|confirmed:@비밀번호" vid="비밀번호 재확인" v-slot="{errors}">
                  <label>비밀번호 확인<span class="labelItem">*</span></label>
                  <input type="password" v-model="confirmedPassword" maxlength="16">
                  <span class="notValidationTxt">{{errors[0]}}</span>
                </ValidationProvider>
                <ValidationProvider class="inputBox infoBox wd50" name="이름" rules="required|name" v-slot="{errors}">
                  <label>이름<span class="labelItem">*</span></label>
                  <input v-model="signupInfo.name" maxlength="16">
                  <span class="notValidationTxt">{{errors[0]}}</span>
                </ValidationProvider>
              </div>
              <div class="btnBox flex topPd">
                <button type="button" class="btnFont redborderBtn"  @click="onClickCancel">취 소</button>
                <button type="submit" class="btnFont redBtn">등 록</button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import {mapActions} from 'vuex'
import * as eventUtil from '@/utils/eventUtil'

export default {
  components:{
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      eventUtil: eventUtil,
      signupInfo:{
        roleName: this.$role.USER,
        id: '',
        password: '',
        name: '',
        email: '',
        phoneNumber: '',
      },
      checkedId: '',          // 중복검사 완료된 아이디
      confirmedPassword: '',  // 비밀번호 재확인 값
    }
  },
  methods:{
    ...mapActions('auth', [
      'isAlreadyExistUsername', 
      'signup',
    ]),
    onClickConfirmId(){
      if(!this.signupInfo.id){
        this.$alert("알림", "아이디를 입력해주세요.");
        return false;
      }

      this.isAlreadyExistUsername(this.signupInfo.id)
      .then((response) => {
        const data = response.data

        var requestId = data.REQUEST_USERNAME
        var result = data.RESULT

        if(result == true){
          this.checkedId = ''
          this.$alert("알림", "이미 존재하는 아이디 입니다.");
        }
        else {
          this.checkedId = requestId
          this.$alert("알림", "사용 가능한 아이디 입니다.");
        }
      })
      .catch(() => {
        this.checkedId = ''
      })
    },
    onClickCancel(){
      this.$router.go(-1)
    },
    onClickSubmit(){
      if(!(this.signupInfo.id === this.checkedId)){
        this.$alert("알림", "아이디 중복확인을 해주세요.");
        return
      }
      if(!(this.signupInfo.password === this.confirmedPassword)){
        this.$alert("알림", "비밀번호가 일치하지 않습니다.");
        return
      }

      const signupInfo = this.signupInfo
      this.signup(signupInfo)
      .then(() => {
        this.$alert("알림", "회원등록이 완료되었습니다.");
        this.$router.go(-1)
      })
      .catch((error) => {
        var data = error.response.data
        switch(data.ERROR){
          case "ALREADY_EXIST_ID":
            this.$alert("알림", "사용중인 아이디 입니다.")
            break
          case "ALREADY_EXIST_EMAIL":
            this.$alert("알림", "사용중인 이메일 입니다.")
            break
          case "ALREADY_EXIST_PHONE_NUMBER":
            this.$alert("알림", "사용중인 전화번호 입니다.")
            break
          default:
            this.$alert("알림", "요청 실패")
            break
        }
      })
    }
  }
}
</script>